import React, {Component} from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import {LeftArrow, RightArrow} from "../Home/Affiliations";

const SliderContainer = styled.div`
  display: block;
  width: 100%;
  
  @media (min-width: 768px) {
    display: none;
  }
  
  .slick-prev {
    left: 0;
    z-index: 10;
  }
  
  .slick-next {
    right: 0;
    z-index: 10;
  }
`;

const Container = styled.div`
  font-family: Cabin-Bold, sans-serif;
  display: flex !important;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;
  //width: 100px;
 	margin: 200px 0;

  
  @media (min-width: 768px) {
    display: none;
  }
 `;

const Bubble = styled.div`
  background: #004a87;
  color: #fff;
  border-radius: 50%;
	width: 80px;
	height: 80px;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1;
	font-family: Cabin-Bold, sans-serif;
	font-size: 22px;
`;

const Text = styled.div`
  text-align: center;
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  background: #fff;
  font-family: Cabin-Bold, sans-serif;
  font-size: 17px;
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  
  ${props => props.top ?
  'top: 0;' : 'bottom: 0;'
  };
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  background: #fff;
  width: 100%;
  ${props => props.top ?
  'bottom: 0; top: -125px;' : 'bottom: -125px; top: 0;'
  }
  
  :before {
    content: "";
    background: #dedede;
    width: 2px;
    top: 0;
    bottom: 0;
    position: absolute;
  }
`;


class TimelineSlider extends Component {
    render() {
        const settings = {
            dots: false,
            nextArrow: <RightArrow/>,
            prevArrow: <LeftArrow/>,
            infinite: false,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
        };
        const {data} = this.props;
        return (
          <SliderContainer>
              <Slider {...settings} >
                  {data.map((i, index) => {
                      const top = (index % 2 === 0);
                      return (
                        <div key={index}>
                            <Container top={top}>
                                {top ?
                                  <TextContainer top={top}>
                                      <Text
                                        top={top}
                                        dangerouslySetInnerHTML={{__html: i.text}}
                                      />
                                  </TextContainer> :
                                  <Bubble>{i.year}</Bubble>
                                }
                                {top ?
                                  <Bubble>{i.year}</Bubble> :
                                  <TextContainer>
                                      <Text
                                        top={top}
                                        dangerouslySetInnerHTML={{__html: i.text}}
                                      />
                                  </TextContainer>
                                }
                            </Container>
                        </div>
                      )
                  })}
              </Slider>
          </SliderContainer>
        );
    }
}

export default TimelineSlider;


// WEBPACK FOOTER //
// ./src/components/GetToKnow/TimelineSlider.js